/* eslint-disable sort-imports */
import { isValidPurchaseDates } from '../../lib/dates';
import {
  GET_ACCOMMODATION_EXTRAS_SUCCESS,
  GET_EXTRAS_AVAILABILITY_SUCCESS,
  GET_EXTRAS_SUCCESS,
  GET_EXTRA_AVAILABILITY_SUCCESS,
} from './types';

const initialState = {
  extras: [],
  groups: [],
  options: [],
};

const initialAccommodationExtrasState = {
  accommodationExtras: [],
  accommodationGroups: [],
  accommodationOptions: [],
  currentAccommodationId: null,
};

/**
 * Normalises extras, groups and options separately
 *
 * @param {Object[]} extras extras data
 * @returns {Object} extras data shape
 */
const transformExtrasData = (extras = []) => {
  const extraExtras = [];
  const extraGroups = [];
  const extraOptions = [];

  extras
    .filter(({ rules = {} }) => {
      const {
        purchase_start_date = {},
        purchase_end_date = {},
        purchase_dashboard,
      } = rules;

      return (
        purchase_dashboard &&
        isValidPurchaseDates(purchase_start_date, purchase_end_date)
      );
    })
    .map(extra => {
      const { groups = [], ...extraData } = extra;

      extraExtras.push(extraData);

      groups.map(group => {
        const { options = [], ...groupData } = group;

        extraGroups.push({
          ...groupData,
          extra_id: extraData.id,
        });

        options.map(option => {
          extraOptions.push({
            ...option,
            extra_id: extraData.id,
            group_id: groupData.id,
          });
          return null;
        });
        return null;
      });
      return null;
    });

  return {
    extras: extraExtras,
    groups: extraGroups,
    options: extraOptions,
  };
};

/**
 * Normalises accommodation extras, groups and options separately
 *
 * @param {Object[]} accommodationExtras accommodation extras data
 * @returns {Object} accommodation extras data shape
 */
const transformAccommodationExtrasData = (accommodationExtras = []) => {
  const extras = [];
  const groups = [];
  const options = [];

  accommodationExtras.map(extra => {
    const { groups: extraGroups = [], ...extraData } = extra;

    extras.push(extraData);

    extraGroups.map(group => {
      const { options: groupOptions = [], ...groupData } = group;

      groups.push({
        ...groupData,
        extra_id: extraData.id,
      });

      groupOptions.map(option => {
        options.push({
          ...option,
          extra_id: extraData.id,
          group_id: groupData.id,
        });
        return null;
      });
      return null;
    });
    return null;
  });

  return {
    accommodationExtras: extras,
    accommodationGroups: groups,
    accommodationOptions: options,
  };
};

/**
 * Merges availability data into options
 *
 * @param {Object[]} state state
 * @param {Object[]} availability availability data
 * @returns {Object[]} state
 */
const mergeOptions = (state, availability) =>
  state.map(option => {
    const optAvail = availability.find(
      ({ option_id }) => option_id === option.id,
    );
    return optAvail
      ? {
          ...option,
          freesale: optAvail.freesale,
          available: optAvail.available,
        }
      : option;
  });

const extrasReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EXTRAS_SUCCESS:
      return {
        ...initialState,
        ...transformExtrasData(action.payload.extras),
      };
    case GET_ACCOMMODATION_EXTRAS_SUCCESS:
      return {
        ...state,
        ...initialAccommodationExtrasState,
        ...transformAccommodationExtrasData(action.payload.accommodationExtras),
        currentAccommodationId: action.payload.accommodationId,
      };
    case GET_EXTRAS_AVAILABILITY_SUCCESS:
      return {
        ...state,
        options: mergeOptions(state.options, action.payload.availability),
      };
    case GET_EXTRA_AVAILABILITY_SUCCESS:
      return {
        ...state,
        options: mergeOptions(state.options, action.payload.availability),
      };
    default:
      return state;
  }
};

export default extrasReducer;
